<template>
  <div class="instruction">
    <BaseText1 :text="instructionNumber"/>
    <BaseText11 class="text-primary" :text="textPrimary"/>
    <BaseText6 :text="textSecondary"/>
  </div>
</template>

<script>
import BaseText1 from '@/components/BaseText1/BaseText1'
import BaseText11 from '@/components/BaseText11/BaseText11'
import BaseText6 from '@/components/BaseText6/BaseText6'
export default {
  props: {
    instructionNumber: {
      type: String,
      required: true
    },
    textPrimary: {
      type: String,
      required: true
    },
    textSecondary: {
      type: String,
      required: true
    }
  },
  components: {
    BaseText1,
    BaseText11,
    BaseText6
  },
  mounted () {
    localStorage.setItem('userHasSeenInstructions', true)
  }
}
</script>

<style lang="scss" scoped>
.instruction {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: var(--spacing-1);
}
.base-lottie {
  width: 6em;
  height: 6em;
}
.base-text-1::after {
  content: '';
  position: absolute;
  width: 0.9rem;
  height: 0.25rem;
  margin: 1rem 0 0 0.5rem;
  transform: skewX(-15deg);
  background: var(--color-red-1);
}
.text-primary {
  margin: 2.5rem 0;
}
</style>
